import $ from "jquery";
import { getConfig, checkNested } from "#scripts/general_functions.js";

export const search = (val = "*") => {
	const searchOn = $.trim(val);
	const config = getConfig();

	if (window.serverdata.configMeta.aim.lang === undefined) {
		window.serverdata.configMeta.aim.lang = "nb";
	}
	const searchLang =
		localStorage.getItem("currentLanguage") ||
		`${window.serverdata.configMeta.aim.lang}_no`;

	$.ajax({
		type: "POST",
		headers: {
			ApiKey: "f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45",
			"Content-Type": "application/graphql",
		},
		url: window.searchEngine,
		data: `
                query {      
                    index {
                        items (
                            filter: {
                                searchQuery: "${searchOn}",       
                                skip: 0,
                                take: 3,
                                queryType: MATCHALL,
                                sortBy: RELEVANCE,
                                categories: [
                                   { values: ["contentSubscribers", "${config.clientId}"] },
                                   { values: ["Language", "${searchLang}"] }
                                ]
                            }                 
                        )    
                        {
                            hits,results {
                                title, date, content, id, url, relevance, extracts, 
                                metadata {
                                    name, value
                                },
                                categories {
                                    values
                                }
                            }
                        }
                    } 
                }`,
		success: (data) => {
			if (checkNested(data, "index", "items")) {
				// const result = data.data.index.items;
				// const newOb = {
				//   data: {
				//     index: {
				//       items: {
				//         // results: [data[0]]
				//       }
				//     }
				//   }
				// };
				// window.messagesToDisplay.push({id: createGuid(), html : addBotMessage({ type: "searchlinks", payload: newOb.data })})
				// CHANGECONV $("#kari__dialog__window").append(addBotMessage({ type: "searchlinks", payload: newOb.data }));
				// messagequeue.push(addBotMessage({ type: "searchlinks", payload: newOb.data }, false, "bot__searchresult"))
				//     let hits = data.index.items.hits;
				//     let res_ = data.index.items.results;
				//     let pagetype = false;
				//     if (checkNested(res_[0], "metadata")) {
				//         pagetype = getMetaValue(res_[0].metadata, "PageTypeId");
				//     }
				//     if (res_.length === 1 && pagetype === "mal_blokk") {
				//         messagefromSystem(language("RESULTS_FROM_WEBSEARCH"));
				//         let id = getMetadataValue(res_[0], "ContentId")
				//         console.log("TEST");
				//         getAimData(id, siteConfig.servioId);
				//     }
				//     else if (res_.length > 1 && hits <= 3) {
				//         messagefromSystem(language("RESULTS_FROM_WEBSITE_ANSWER"));
				//         $("#kari__dialog__window").append(addBotMessage({ type: "searchlinks", payload: data }));
				//     }
				//     else if (res_.length > 1 && res_.length <= hits) {
				//         messagefromSystem(language("MANY_ANSWERS_P1") + " (" + hits + "). " + language("MANY_ANSWERS_P2"));
				//         $("#kari__dialog__window").append(addBotMessage({ type: "searchlinks", payload: data }));
				//         messagefromSystem("<a href='/search/" + searchOn + "'>Gå til søk</a>");
				//     }
				//     else if (res_.length < 1) {
				//         messagefromSystem(language("NO_ANSWER_QUERY"));
				//     }
				//     else {
				//         messagefromSystem(language("ERROR_WHILE_SEARCH"));
				//     }
				//     $(".removewhendone").remove();
				// }
				// else {
				//     console.error("No matches");
				// }
				// setScrollBottom();
			}
		},
	});
};
